/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

/**
 * Product specification table row.
 */
export interface IProductSpecificationTableRow {
    productName?: string;
    cellData?: any; //changed to any from React.ReactNode (could not access props for comparison)
    className?: string;
    iconName?: string;
}

/**
 * Product specification table row component.
 * @param props - For product specification table row.
 * @param props.productName - Product name.
 * @param props.cellData - Cell data.
 * @param props.className - Class name.
 * @param props.iconName
 * @returns - Returns JSX element.
 */

export const ProductSpecificationTableRow: React.FC<IProductSpecificationTableRow> = ({ productName, cellData, className, iconName }) => (
    <tr className={className}>
        <td className='attribute-table-cell'>
            <span className={`${iconName}-icon product-attribute-icon`}></span>
            <span>{cellData}</span>
        </td>
    </tr>
);
